var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGoogle = function SvgGoogle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4280EF",
    d: "M35.4 18.425c0-1.198-.116-2.436-.31-3.596H18.349v6.844h9.59a8.07 8.07 0 0 1-3.558 5.375l5.723 4.447c3.364-3.132 5.297-7.695 5.297-13.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A353",
    d: "M18.348 35.748c4.795 0 8.816-1.585 11.755-4.292l-5.723-4.408c-1.585 1.083-3.635 1.701-6.032 1.701-4.64 0-8.545-3.132-9.976-7.308l-5.877 4.524a17.73 17.73 0 0 0 15.853 9.783"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B704",
    d: "M8.372 21.403a10.8 10.8 0 0 1 0-6.806l-5.877-4.562c-2.514 5.026-2.514 10.942 0 15.93z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E54335",
    d: "M18.348 7.29a9.68 9.68 0 0 1 6.805 2.667l5.066-5.104C27.009 1.837 22.756.213 18.348.252a17.73 17.73 0 0 0-15.853 9.783l5.877 4.562c1.43-4.214 5.336-7.308 9.976-7.308"
  })));
};
export default SvgGoogle;